export default __webpack_public_path__ + "assets/detect-2.c1f8779a.png";